import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { get } from "../../../../../../utils/request";
import { getQueryValue } from "../../../../../../utils/tool";
import { actions as majorqueryActions } from "../../../../../../redux/modules/majorquery";
import "./style.css";
class MajorQueryKeySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickName: "取消",
      name: "",
      majors: [],
    };
  }
  componentDidMount() {
    this.textInput.focus();
  }
  render() {
    const { placeholder } = this.props;
    const { majors } = this.state;
    return (
      <div className="majorQueryKeySearch_box">
        <div className="majorQueryKeySearch_box_left fl">
          <div className="majorQueryKeySearch_box_left_div">
            <div className="majorQueryKeySearch_box_left_div_img fl">
              <img
                alt=""
                src={require("../../../../../../images/search/search_2.png")}
              ></img>
            </div>
            <div className="majorQueryKeySearch_box_left_div_input fl">
              <input
                value={this.state.name}
                onChange={this.handleChang}
                ref={(input) => {
                  this.textInput = input;
                }}
                placeholder={placeholder}
              ></input>
            </div>
            <div
              style={{
                display: this.state.clickName === "搜索" ? "block" : "none",
              }}
              className="majorQueryKeySearch_box_right_div_img fr"
              onClick={() => this.handleRemoveName()}
            >
              <img
                alt=""
                src={require("../../../../../../images/search/search_3.png")}
              ></img>
            </div>
          </div>
        </div>
        <div className="majorQueryKeySearch_box_right fl">
          <div
            onClick={this.handleSearch}
            className="majorQueryKeySearch_box_right_txt fl"
          >
            {this.state.clickName}
          </div>
        </div>
        <div className="clear"></div>
        <div className="majorQueryKeySearch_box_item">
          {majors.map((item, index) => {
            return (
              <div
                key={index}
                onClick={this.handleClick.bind(this, item)}
                className="majorQueryKeySearch_item"
              >
                {item}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  /**
   * 点击搜索跳转到专业查询列表页面
   */
  handleSearch = () => {
    //todo 点击搜索的时候，将专业存入redux 以及 sessionStorage 并且跳转到专业查询列表页面
    if (this.state.clickName === "取消") {
      this.setState({
        clickName: "取消",
        name: "",
        majors: [],
      });
      this.props.history.push(getQueryValue("from"));
    } else {
      this.storageMajor(this.state.name);
      this.props.history.push("/majorquery/list");
    }
  };
  /**
   * 点击专业跳转到专业查询列表页面
   */
  handleClick = (item) => {
    this.storageMajor(item);
    this.props.history.push("/majorquery/list");
  };

  /**
   * 存数据
   */
  storageMajor = (name) => {
    //todo 点击专业的时候 将专业存入redux 以及 sessionStorage 并且跳转到专业查询列表页面
    //存两份数据 一份存sessionStorage，一份存redux 。
    const { dispatch } = this.props;
    dispatch(majorqueryActions.cacheMajor(name));
    sessionStorage.setItem("query_major", JSON.stringify(name));
  };

  /**
   * input输入框变化的时候
   */
  handleChang = (e) => {
    this.setState({
      name: e.target.value,
    });
    if (e.target.value.length > 0) {
      this.setState({
        clickName: "搜索",
      });
      get("/public/v1/major/search/" + e.target.value).then((res) => {
        this.setState({
          majors: res.data,
        });
      });
    } else {
      this.setState({
        clickName: "取消",
        majors: [],
      });
    }
  };
  /**
   * 移除搜索的院校名称
   */
  handleRemoveName = () => {
    this.setState({
      clickName: "取消",
      name: "",
      majors: [],
    });
  };
}

export default connect()(withRouter(MajorQueryKeySearch));



// WEBPACK FOOTER //
// ./src/containers/PowerfulQuery/components/MajorQuery/components/MajorQueryKeySearch/index.js